import React, { useEffect } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import "../Styles/Co2ProductStyle.css";
import co2HeroImage from '../Assets/codevice.png';
import co2InUse from '../Assets/coin.jpeg';
import co2Background from '../Assets/coback.png';
import co2Features from '../Assets/cotrust.png';
import handco2 from '../Assets/handco2.png';
const Co2LaserPage = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: false
    });
  }, []);

 const handleOpenPDF = () => {
  // Using fetch to get the file as blob
  fetch("https://romanqadir.github.io/jsonapi/co2catalogue.pdf")
    .then(response => response.blob())
    .then(blob => {
      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Create a temporary anchor element
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'co2-catalogue.pdf'; // Specify the filename for download
      
      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up the blob URL
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch(error => {
      console.error('Download failed:', error);
      // Fallback to opening in new tab if download fails
      window.open("https://romanqadir.github.io/jsonapi/co2catalogue.pdf", '_blank');
    });

  };

  return (
    <div className="co2-product-page">
      {/* Hero Section */}
       <section 
              className="hero-section" 
              style={{ backgroundImage: `url(${co2Background})` }}
            >
               <Container>
          <Row className="align-items-center min-vh-80">
            <Col md={6} className="hero-content" data-aos="fade-right">
              <h1 className="product-title animate-charcter-co2">EPILYUM AXISONE CO₂</h1>
              <h2 className="product-subtitle typed-text">
                Super Pulse CO₂ Laser with Multi Mode
              </h2>
             
            </Col>
            <Col md={6} className="text-center" data-aos="fade-left" data-aos-delay="200">
              <Image 
                src={co2HeroImage} 
                fluid 
                className="product-hero-image floating" 
                alt="AxisOne CO₂ Laser Device"
              />
            </Col>
          </Row>
        </Container>
            </section>
    
 
       
      
      {/* Product Description Section */}
      <section className="product-description py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} className="text-center" data-aos="fade-up">
              <div className="laser-icon mb-4" data-aos="zoom-in">
                <i className="fas fa-burn"></i>
              </div>
              <p className="intro-text co2-description">
                CO₂ fractional laser is a far-infrared laser that delivers high-energy pulses focused on microscopic treatment zones. 
                The intense heat instantly vaporizes targeted skin columns, creating precise microthermal ablation channels while 
                inducing controlled thermal diffusion to surrounding tissue. This thermal effect coagulates collagen around the 
                ablation zone, forming a protective barrier that reduces infection risk. Additionally, heat diffusion stimulates 
                fibroblast activity, promoting neocollagenesis and accelerating skin remodeling.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Trust Section with Image */}
      <section className="trust-section py-5 bg-light">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-5 mb-lg-0" data-aos="fade-right">
              <h2 className="section-title co2-title">
                Why Professionals Trust <span className="text-highlight">AxisOne CO₂</span>?
              </h2>
              <div className="divider mb-4"></div>
              
              <ul className="trust-list">
                <li data-aos="fade-up">
                  <i className="fas fa-check-circle me-2"></i> Advanced RF Metal Tube Technology
                </li>
                <li data-aos="fade-up" data-aos-delay="100">
                  <i className="fas fa-check-circle me-2"></i> Physician-Tested Excellence
                </li>
                <li data-aos="fade-up" data-aos-delay="200">
                  <i className="fas fa-check-circle me-2"></i> Ultra-Short Pulse Technology
                </li>
                <li data-aos="fade-up" data-aos-delay="300">
                  <i className="fas fa-check-circle me-2"></i> Global Medical Trust
                </li>
              </ul>
            </Col>
            <Col lg={6} data-aos="fade-left" data-aos-delay="200">
              <div className="trust-image-container">
                <Image 
                  src={co2InUse} 
                  fluid 
                  className="trust-image rounded-lg shadow-lg" 
                  alt="CO₂ Laser in clinical use"
                />
                <div className="floating-badge" data-aos="fade-down-left">
                  <span>90% Patient Satisfaction</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

<section className="trust-section py-5 bg-light">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-5 mb-lg-0" data-aos="fade-right">
              <h2 className="section-title co2-title">
               4 different types of <span className="text-highlight">Handpieces</span>?
              </h2>
              <div className="divider mb-4"></div>
              
              <ul className="trust-list">
                <li data-aos="fade-up">
                  <i className="fas fa-check-circle me-2"></i> 1: Fractional Handpiece → Fractional Resurfacing Module
                </li>
                <li data-aos="fade-up" data-aos-delay="100">
                  <i className="fas fa-check-circle me-2"></i> 2:Surgical Handpiece → Precision Surgical Module
                </li>
                <li data-aos="fade-up" data-aos-delay="200">
                  <i className="fas fa-check-circle me-2"></i> 3: Gynecology Handpiece → Gynecological Treatment Module
                </li>
                <li data-aos="fade-up" data-aos-delay="300">
                  <i className="fas fa-check-circle me-2"></i>4: protective tip - reducing the risk of deep-tissue injury.
                </li>
              </ul>
            </Col>
            <Col lg={6} data-aos="fade-left" data-aos-delay="200">
              <div className="trust-image-container">
                <Image 
                  src={handco2} 
                  fluid 
                  className="trust-image rounded-lg shadow-lg" 
                  alt="CO₂ Laser in clinical use"
                />
               
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Modes Section */}
      <section className="modes-section py-5">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title co2-title" data-aos="fade-up">
                Advanced <span className="text-highlight">Treatment Modes</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          <Row className="g-4">
            {[
              {
                title: "Deep Mode",
                icon: "fas fa-layer-group",
                description: "Delivers energy deep into dermal tissue, achieving a powerful fractional effect through the precise combination of controlled ablation and effective coagulation for enhanced remodeling.",
                delay: 0
              },
              {
                title: "Ablative Mode",
                icon: "fas fa-cut",
                description: "Delivers precise superficial fractional treatments in the epidermis to stimulate cellular renewal, while also penetrating deeper to achieve an intensified fractional ablative effect on structures below the dermal–epidermal junction, making it ideal for delicate areas such as eyelid tightening.",
                delay: 100
              },
              {
                title: "Combo Mode",
                icon: "fas fa-random",
                description: "Utilizes a sophisticated scan pattern that synchronizes varied penetration depths with controlled thermal energy, delivering optimized, simultaneous treatment of both epidermal and dermal layers for superior clinical results.",
                delay: 200
              }
            ].map((mode, index) => (
              <Col md={4} key={index} data-aos="fade-up" data-aos-delay={mode.delay}>
                <div className="mode-card">
                  <div className="mode-icon">
                    <i className={mode.icon}></i>
                  </div>
                  <h4>{mode.title}</h4>
                  <p>{mode.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Mode Visualization Image */}
      <section className="mode-visualization py-5 bg-light">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} data-aos="zoom-in">
              <div className="visualization-container">
                <Image 
                  src={co2Features} 
                  fluid 
                  className="mode-image shadow-lg" 
                  alt="CO₂ Laser Modes Visualization"
                />
                <div className="image-caption text-center mt-4">
                  AxisOne CO₂ Laser - Multi-mode treatment depth visualization
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Catalog Section */}
      <section className="co2-catalog-section py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center" data-aos="fade-up">
              <h2 className="section-title co2-title mb-4">
                Download <span className="text-highlight">Product Catalogue</span>
              </h2>
              <p className="lead mb-5">
                Get complete technical specifications and clinical protocols for AxisOne CO₂
              </p>
              
              <div className="catalog-preview mb-5" data-aos="zoom-in">
                <div className="catalog-frame">
                  <Image 
                    src={require('../Assets/cocat.png')} 
                    fluid 
                    className="catalog-thumbnail"
                    alt="CO₂ Laser Catalog Preview"
                  />
                  <div className="catalog-overlay" onClick={handleOpenPDF}>
                    <span className="overlay-text">Click to Preview</span>
                  </div>
                </div>
              </div>
              
              <button 
                onClick={handleOpenPDF}
                className="btn btn-primary btn-lg download-btn pulse"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <i className="fas fa-download me-2"></i> Download Full Catalogue (PDF)
              </button>
              
              <p className="mt-3 text-muted" data-aos="fade-up" data-aos-delay="300">
               
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Co2LaserPage;